import { Component } from '@angular/core';
import { IntersectionObserverDirective } from "../../../core/directives/animate-on-visible.directive";

@Component({
  selector: 'app-milestones',
  imports: [IntersectionObserverDirective],
  templateUrl: './milestones.html',
  styleUrl: './milestones.scss',
})
export class Milestones {

}
